module.exports = __webpack_public_path__ + "img/terminal.8f4c670e.svg";